import * as React from "react";

function SvgCatalog(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" {...props}><path d="M9.11 5.616h-2.1v-2.1a.7.7 0 10-1.399 0v2.1H3.513a.7.7 0 000 1.4H5.61v2.1a.7.7 0 101.4 0v-2.1h2.098a.7.7 0 000-1.4zm4.693 7.204l-2.595-2.577a6.305 6.305 0 00-.71-8.634A6.294 6.294 0 00.002 6.129 6.304 6.304 0 005.78 12.58a6.293 6.293 0 004.455-1.364l2.575 2.576a.701.701 0 00.993 0 .7.7 0 000-.973zm-7.492-1.604a4.894 4.894 0 01-4.524-3.025A4.904 4.904 0 015.356 1.51a4.894 4.894 0 015.027 2.084 4.903 4.903 0 01-4.072 7.623z" /></svg>;
}

export default SvgCatalog;